export default __webpack_public_path__ + "static/media/viewclass.57a54ea0.svg";